import merge from 'lodash/merge'
import initialStateEntities from '../data/entities'
import { 
  SET_ENTITY_IS_LOADING,
  UNSET_ENTITY_IS_LOADING,
  UNSET_SELECTED_ENTITY,
  // BATTERIES_REQUEST,
  // BATTERIES_SUCCESS,
} from '../actions'

const spreadLatLng = (object, offset = 0, multiplier = 1) => {

  let r = 100000

  if (object && object.lat && object.lng) {

    let latRemainder = (object.lat*r)%Math.floor(object.lat*r)
    let lngRemainder = (object.lng*r)%Math.floor(object.lng*r)

    if (latRemainder == 0 || lngRemainder == 0) {
      let lat = object.lat
      let lng = object.lng

      let angle = Math.sqrt(offset) * 887 // object.id

      let x = angle*Math.cos(angle)
      let y = angle*Math.sin(angle)

      lat += y/1000000 * multiplier
      lng += x/1000000 * multiplier

      object.lat = lat // +offset
      object.lng = lng // +offset
    }
  }

  return object
}


// Updates an entity cache in response to any action with response.entities.
function entities(state = initialStateEntities, action) {

  let newState = Object.assign({}, state)

  switch (action.type) {
    case SET_ENTITY_IS_LOADING : 
      return Object.assign({}, state, {
        entity_is_loading: true,
        entity_type: action.entityType,
      })
    case UNSET_ENTITY_IS_LOADING : 
      return Object.assign({}, state, {
        entity_is_loading: false,
        selected: null,
      })
    case UNSET_SELECTED_ENTITY :
      return Object.assign({}, state, {
        selected: null,
        entity_is_loading: false,
      })
  }
  if (action.response && action.response.entities) {

    let newEntities = action.response.entities
    // console.log(newEntities)
    if (newEntities.hasOwnProperty('batteries')) {
      newEntities.batteryLocations = newState.batteryLocations
      newEntities = Object.keys(newEntities.batteries).reduce((acc, batteryId, index) => {
        let battery = acc.batteries[batteryId]
        if ( ! battery.weight) {
          battery.weight = 1
        }
        if (newState.batteries.hasOwnProperty(batteryId)) {
          battery.lat = newState.batteries[batteryId].lat
          battery.lng = newState.batteries[batteryId].lng
          // battery.weight = newState.batteries[batteryId].weight
  // if (batteryId == 33 || batteryId == 442) {
  //   console.log(newState.batteries[batteryId].weight)
  // }
        } else {
          let location = battery.lng+'|'+battery.lat
          if (newState.batteryLocations[location] && newState.batteryLocations[location] >= 1) {
            newState.batteryLocations[location] += 1
            battery = spreadLatLng(battery, newState.batteryLocations[location])
            // console.log('spreadLatLng',battery)
          } else {
            newState.batteryLocations[location] = 1
          }
        }
        acc.batteries[batteryId] = battery
        return acc
      }, newEntities)
    }
    // console.log(newEntities)
    newState = merge({}, newState, newEntities)
    // console.log(newState)
    
    let key = Object.keys(action.response.entities)[0]
    if (newState.entity_is_loading && typeof action.response.result === 'number' && action.response.entities[key][action.response.result]) {
      newState['selected'] = Object.assign({}, 
        action.response.entities[key][action.response.result],
        {
          lat: newState[key][action.response.result].lat,
          lng: newState[key][action.response.result].lng,
        }
      ) || {}
      newState['entity_is_loading'] = false
    }
  }

  return newState
}

export default entities


// WEBPACK FOOTER //
// ./src/reducers/entities.js